import { render, staticRenderFns } from "./psp-type-form.vue?vue&type=template&id=4b38fae2&"
import script from "./psp-type-form.vue?vue&type=script&lang=js&"
export * from "./psp-type-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports